export default __webpack_public_path__ + "static/logo-unilever-fff3d81eedb2c59a949451dfe722c14d.png";